import {
  getAllCommunications,
  getFilteredCommunications,
  postCommunication,
  updateCommunication,
  disableCommunication
} from '@/api/Erp'

export default {
  async getAllCommunications(page, size, product_id, search_text, token) {
    try {
      const response = await getAllCommunications.get({
        uriParams: {
          page,
          size,
          product_id,
          search_text
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
  async getFilteredCommunications(is_active, page, size, product_id, search_text, token) {
    try {
      const response = await getFilteredCommunications.get({
        uriParams: {
          is_active,
          page,
          size,
          product_id,
          search_text
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
  async postCommunication(payload, token) {
    try {
      const response = postCommunication.post(
        payload,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      )
      return response
    } catch (error) {
      return error.response
    }
  },
  async updateCommunication(payload, token) {
    try {
      const communication_id = payload.communication_id
      const response = await updateCommunication.patch(
        payload,
        {
          uriParams: {
            id: communication_id
          },
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      )
      return response
    } catch (error) {
      return error.response
    }
  },
  async disableCommunication(payload, token) {
    try {
      const communication_id = payload.communication_id
      const response = disableCommunication.delete({
        uriParams: {
          id: communication_id
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/communication/resources.js